<template>
  <div class="items">
    <div class="items--toolbox">
    </div>
    <div class="info-card">
      <InfoCard v-if="lastHistory"
                bg-color="#52455f"
                textColor="black"
                msg="Dernière commande passée le: "
                :data="lastHistory | concatenateDateAndTime"
                width="350px"
                icon="el-icon-date"></InfoCard>
      <InfoCard v-if="settings.shouldDisplayPrice"
                bg-color="#fe4a49"
                textColor="black"
                msg="Prix total"
                :data="totalPrice"
                width="350px"
                icon="el-icon-money"></InfoCard>
      <el-switch
        style="display: flex; margin-left: 20px; margin-right: 0; justify-content: flex-end;"
        v-model="isList"
        active-color="#13ce66"
        inactive-color="#ff4949"
        active-text="tableau"
        inactive-text="tuiles">
      </el-switch>
    </div>
    <el-divider class="divider"></el-divider>
    <div v-if="this.filters.supplier ? isFranco : true" class="franco-bar">
      <h2> progression minimum de commande: </h2>
      <el-progress :percentage="franco"
                   :text-inside="true"
                   :stroke-width="26"
                   :color="customColors"
                   class="franco-bar--progress"></el-progress>
    </div>
    <el-divider class="divider"></el-divider>
    <div class="filters">
      <Autocomplete class="items--autocomplete column-margin"
                    :placeholder="$t('home.placeholder')"
                    :array-to-filter="items"
                    :key-to-filter="keyToFilter"
                    @bubbleUpInput="filterByAutocomplete($event)"></Autocomplete>
      <el-dropdown class="el-dropdown">
        <el-button class="filter-first"
                   type=""
                   icon="el-icon-s-shop">
          Sélection fournisseurs<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="supplier in suppliers"
                            v-bind:key="supplier"
                            class="column">
            <el-radio
              :v-model="supplier"
              :label="supplier"
              @change="filterBySupplier(supplier)">
            </el-radio>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown class="el-dropdown">
        <el-button class="filter-second" type="" icon="el-icon-price-tag">
          Sélection Tag<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="tag in tags"
                            v-bind:key="tag"
                            class="column">
            <el-radio
              :v-model="tag"
              :label="tag"
              @change="filterByTag(tag)">
            </el-radio>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type=""
                 class="filters--last"
                 icon="el-icon-circle-close"
                 @click="resetFilters()">
        Réinitialiser les filtres
      </el-button>
    </div>

    <Tiles v-if="this.items"
           :hidden="isList"
           :products="this.items"
           :loading="loading"
           :filters="filters"></Tiles>
    <ProductsTable v-if="this.items"
                   :hidden="!isList"
                   :products="this.items"
                   :loading="loading"
                   :filters="filters"
                   class="products"></ProductsTable>
    <el-divider></el-divider>
    <div class="card-footer pagination">
    </div>
    <el-link class="copyright"
             href="https://www.marieblachere.com/"> {{ $t('home.marieBlachereLink') }}
    </el-link>
  </div>
</template>

<script>
  import services from 'services';
  import ProductsTable from '@/components/ProductsTable/productsTable.vue';
  import Autocomplete from './Autocomplete/Autocomplete.vue';
  import InfoCard from './infoCard/InfoCard.vue';
  import '@/filters/date.filter';
  import Tiles from './Tiles/Tiles.vue';

  const customStyles = {
    ul: {
      border: '1px solid black',
    },
    li: {
      borderRight: '1px solid black',
      cursor: 'pointer',
      display: 'inline-block',
      hover: 'red',
    },
    a: {
      display: 'inline-block',
      colorHover: 'blue',
      padding: '15px',
    },
  };
  export default {
    components: {
      Tiles,
      Autocomplete,
      ProductsTable,
      InfoCard,
    },
    data() {
      return {
        customColor: '#409eff',
        customColors: [
          {
            color: '#f56c6c',
            percentage: 20,
          },
          {
            color: '#e6a23c',
            percentage: 40,
          },
          {
            color: '#6f7ad3',
            percentage: 60,
          },
          {
            color: '#1989fa',
            percentage: 80,
          },
          {
            color: '#5cb87a',
            percentage: 100,
          },
        ],
        keyToFilter: 'name',
        processedArray: {},
        customStyles,
        checkList: [],
        radio: '',
        isList: true,
        filters: {
          supplier: null,
          tag: null,
          autocomplete: '',
        },
      };
    },
    props: {
      msg: String,
      items: {},
      loading: Boolean,
    },
    mounted() {
      this.processedArray = this.items;
      this.filters.supplier = 'AGIDRA';
    },
    watch: {
      items(val) {
        this.processedArray = val;
      },
    },
    computed: {
      settings() {
        return this.$store.getters['settings/settings'];
      },
      lastHistory() {
        return this.$store.getters['history/lastHistory'] ? this.$store.getters['history/lastHistory'].time : null;
      },
      suppliers() {
        return this.$store.getters['supplier/suppliersName'];
      },
      tags() {
        return ['alimentaire', 'fourniture'];
      },
      franco() {
        if (this.filters.supplier) {
          return services.CartService.getFrancoPercentage(this.filters.supplier);
        }
        return services.CartService.getFrancoPercentage(this.suppliers[0]);
      },
      isFranco() {
        if (this.filters.supplier) {
          return !!services.CartService.getFranco(this.filters.supplier);
        }
        return false;
      },
      totalPrice() {
        return `${Math.round(this.$store.getters['cart/cartTotalSumHt'])} €`;
      },
    },
    methods: {
      affectFilteredArray(filteredArray) {
        this.radio = '';
        this.processedArray = filteredArray;
      },
      pushCartRoute() {
        this.$router.push({ name: 'Cart' });
      },
      filterBySupplier(supplier) {
        this.filters.supplier = supplier;
      },
      filterByTag(tag) {
        this.filters.tag = tag;
      },
      filterByAutocomplete(value) {
        this.filters.autocomplete = value;
      },
      resetFilters() {
        this.filters.tag = null;
        this.filters.supplier = null;
        this.filters.autocomplete = '';
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
  @import '~@/assets/css/main.styl';

  .divider {
    width 95%
  }

  .title
    text-align center
    color $dark-color

  .products {
    margin-top 10px
  }

  .items {
    display flex;
    flex-direction column
    justify-content center;
    width: 100%;
    margin-left: 20px;
  }

  .franco-bar {
    display flex
    flex-direction row
    justify-content flex-start
    width: 95%
  }

  .franco-bar--progress {
    margin-left 30px
    padding-top 21px
    width 73%
  }

  .filters {
    margin-right 20px
    display flex
    flex-direction row
    flex-wrap: wrap
    justify-content space-between
    width 95%
  }

  .filter-first {
    background-color $first-filter
    color $light-color
  }

  .filter-second {
    background-color $second-filter
    color $light-color
  }

  .filters--last {
    background-color $third-filter
    color $light-color
  }

  .items--toolbox {
    position sticky
    display flex
    flex-direction row
    width: 100%
    justify-content flex-start
    align-items center
  }

  .info-card {
    display flex
    flex-direction row
    justify-content space-between
    flex-wrap: wrap
    align-items center
    width: 95%
    /*margin-right 20px*/
  }

  @media screen and (max-width: 750px) {
    info-card {
      display flex
      flex-direction column
      width: 95%
      margin-right 20px
    }

    .items--autocomplete {
      width: auto
    }

    .cart-button--name {
      display none
    }
  }

  .items--autocomplete
    width: 50%

  /*.item--dropdown*/
  /*  width 30%*/

  .item--dropdown {
    margin 0 10px;
  }

  .item--dropdown--menu
    display flex
    flex-direction column

  .el-dropdown {
    vertical-align: top;
  }

  .el-icon-arrow-down {
    font-size: 12px;
  }

  .copyright
    margin 50px auto
    text-align center

  h3
    margin 40px 0 0

  a
    color #42b983
    cursor: pointer;

  .items--info-card {
    height 80px
  }

  .el-dropdown {
    vertical-align: top;
  }

  .el-dropdown + .el-dropdown {
    margin-left: 15px;
  }

  .el-icon-arrow-down {
    font-size: 12px;
  }

  .column {
    display flex
    flex-direction column
  }
</style>
